// const ApiUrl = "http://192.168.1.103/Jewellary/tirupur_jewellery";
// const ApiUrl = "http://192.168.1.103/Jewellary/tirupur_jewellery";
// const ApiUrl = "http://localhost";
const ApiUrl = "https://tirupurJewellery.in/";

export default ApiUrl;
